import React, { useEffect, useRef, useState } from 'react';
import MessageList from './MessagesList';
import InputField from './InputField';
import styles from './ChatBotComponent.module.css';
import { Button } from '@mui/material';
import { CircularProgress } from '@mui/material';
import TipsIcon from '../../Assets/svgs/tips.svg';
import {
  deleteRecentQueries,
  getChatHistory,
  getlatestSummary,
  saveChatHistory,
} from '../../Services/chat-bot-service';
import {
  CONTENT_REGEX_TWO,
  CONTENT_REGEX,
  apiBaseURL,
  apiUAE_MT_URL,
  // apiSpendWiseURL,
  // TOPLINE_AUTO_SUGGESTIONS_WHAT,
  restrictedUsers,
  variationData,
  TOPLINE_AUTO_SUGGESTIONS_WHAT_UAE_MT,
  // R_AND_D_AUTO_SUGGESTIONS,
  // SPEND_WISE_SUGGESTIONS,
} from '../../Common/Constants';
import { callLogEvent, getSeconds } from '../../Common/Util';
import { useOktaAuth } from '@okta/okta-react';
import Layout from '../../Common/Components/Layout/Layout';
import TabTitle from '../../Common/Components/TabTitle/TabTitle';
import DashboardListInChat from '../../Common/Components/DashboardListInChat/DashboardListInChat';
import { Col, Row, Spinner } from 'react-bootstrap';
import DOMPurify from 'dompurify';
import axios from 'axios';
import PBIDashboard from '../../Common/Components/PBIDashboard/PBIDashboard';
import { v4 as uuidv4 } from 'uuid';
import CloseIcon from '@mui/icons-material/Close';
import ChatIcon from '../../Assets/svgs/chat-icon.svg';
import UAEFlag from '../../Assets/Images/uae_flag.png';
import KSAFlag from '../../Assets/Images/ksa_flag.png';
import ChatRender from './ChatRender';
import eventEmitter from './EventEmitter';
import { useDispatch } from 'react-redux';
import { updateSummary, updateTitle, updateTreeInfo } from '../../Store/chatBotSlice';
import { useAppSelector } from '../../Store/Store';
import { selectDropdownState } from '../../Store/AuthSlice';
import { getFiltersApi } from '../../Services/chat-bot-service';
import { appendMarketIfNeeded, getApplicationUrl } from '../../Common/httpClient';
import HistoryIcon from '@mui/icons-material/History'; // Icon for 'Recent Queries'
import AddCommentOutlinedIcon from '@mui/icons-material/AddCommentOutlined'; // Icon for 'New Chat'
import MenuIcon from '@mui/icons-material/Menu';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import InfoIcon from '@mui/icons-material/Info';
import {
  Tooltip,
  useMediaQuery,
  useTheme,
  IconButton,
  Drawer,
  Box,
  Typography,
  Dialog,
} from '@mui/material';
import {
  Filter,
  Task,
  ChevronLeft,
  ChevronRight,
  HelpOutline,
  Add,
  Download,
} from '@mui/icons-material';
import HomeIcon from '@mui/icons-material/Home';
import UserGuideUaeMt from './UserGuideUaeMt';
import { sr } from 'date-fns/locale';

interface UaeMtChatComponentProps {
  onReset: () => void;
  initialAction: string | null;
  setHeaderActions: (actions: React.ReactNode | null) => void;
  setCenterTitle: (title: React.ReactNode | null) => void;
}

const UaeMtChatBotComponent = ({
  onReset,
  initialAction,
  setHeaderActions,
  setCenterTitle,
}: UaeMtChatComponentProps) => {
  const getModernTradeTitle = (market: string) => {
    if (market === 'UAE MT') return 'UAE Modern Trade';
    if (market === 'KSA MT') return 'KSA Modern Trade';
    return market;
  };

  const getDataSourceTitle = () => {
    const selectedMarket = localStorage.getItem('SelectedMarket');
    if (selectedMarket) {
      return getModernTradeTitle(selectedMarket);
    }
    const dataSource = (localStorage.getItem('DataSource') || '').toLowerCase();
    if (dataSource === 'uae_mt') return 'UAE Modern Trade';
    if (dataSource === 'ksa_mt') return 'KSA Modern Trade';
    if (!dataSource) return 'UAE Modern Trade';
    return dataSource
      .split('_')
      .filter(Boolean)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ');
  };
  const [pageTitle, setPageTitle] = useState('');
  const secondHeaderTitle = getModernTradeTitle(pageTitle || getDataSourceTitle());
  const [dashboardURL, setDashboardURL] = useState('');
  const [messages, setMessages] = useState<any>([]);
  const [chatHistory, setChatHistory] = useState<any>([]);
  const [isInsightsNavOpen, setIsInsightsNavOpen] = useState(true);
  const [isSummaryHistoryOpen, setIsSummaryHistoryOpen] = useState(false);
  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);
  const [showFilterHelp, setShowFilterHelp] = useState(false);
  const [summaryToolbarState, setSummaryToolbarState] = useState({
    syncFilters: true,
    isSummaryGenerating: false,
  });
  const { authState } = useOktaAuth();
  const result = useAppSelector(selectDropdownState);

  // const switchSuggestion: any = (pageTitle: string) => {
  // 	switch (pageTitle) {
  // 		case 'UAE MT':
  // 			return TOPLINE_AUTO_SUGGESTIONS_WHAT_UAE_MT;
  // 		case 'SpendWise':
  // 			console.log('coming here??');
  // 			return SPEND_WISE_SUGGESTIONS;
  // 		default:
  // 			console.log('coming here to array?????');
  // 			return TOPLINE_AUTO_SUGGESTIONS_WHAT;
  // 	}
  // };

  const [latestSuggestions, setLatestSuggestions] = useState(
    TOPLINE_AUTO_SUGGESTIONS_WHAT_UAE_MT
  );
  const [visibleSuggestions, setVisibleSuggestions] = useState<string[]>(() =>
    (TOPLINE_AUTO_SUGGESTIONS_WHAT_UAE_MT || []).slice(0, 4)
  );
  const [remainingSuggestions, setRemainingSuggestions] = useState<string[]>(
    () => (TOPLINE_AUTO_SUGGESTIONS_WHAT_UAE_MT || []).slice(4)
  );
  const [pendingUsedSuggestion, setPendingUsedSuggestion] = useState<
    string | null
  >(null);
  const [lastUsedSuggestion, setLastUsedSuggestion] = useState<string | null>(
    null
  );
  // const [latestSuggestions, setLatestSuggestions] = useState(
  // 	switchSuggestion(pageTitle)
  // );
  const [isMessageSent, setIsMessageSent] = useState(false);
  const [threadId1, setThreadId1] = useState<any>('');
  const [threadId2, setThreadId2] = useState<any>('');
  const [sessionContext, setSessionContext] = useState<any>([]);
  const [queryAnalyser, setQueryAnalyser] = useState<any>([]);
  const [isIdeal, setIsIdeal] = useState(true);
  const stateRef = useRef();
  const [currentDataSource, setCurrentDataSource] = useState<string>('');
  // Only sanitize agent_metadata when the selected datasource is UAE MT.
  // This component is specific to UAE MT, so use this flag across the component.
  const isUaeMt = localStorage.getItem('DataSource') === 'uae_mt';
  const [inputValue, setInputValue] = useState<string>('');
  const [cancelTokenSource, setCancelTokenSource] = useState<any>();
  const [showDashboard, setShowDashboard] = useState<boolean>(false);
  const [requestId, setRequestId] = useState<string>('');
  const currentUserEmail = sessionStorage.getItem('emailid')?.toLowerCase();
  const [attachmentId, setAttachmentId] = useState<string>('');
  const [isLoading, setLoading] = useState<boolean>(false);
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [isChatPanelOpen, setIsChatPanelOpen] = useState(false);
  const [isChatPanelExpanded, setIsChatPanelExpanded] = useState(false);
  // width in pixels for the docked chat panel. null => use default responsive values
  const [chatPanelWidth, setChatPanelWidth] = useState<number | null>(null);
  const [isUserGuideOpen, setIsUserGuideOpen] = useState(false);
  const [summaryContext, setSummaryContext] = useState<{
    activeInsightSection: string | null;
    activeSummaryMessage: any | null;
  }>({
    activeInsightSection: null,
    activeSummaryMessage: null,
  });
  const [isAskHovered, setIsAskHovered] = useState(false);
  // controls visibility of the tips bar immediately under the chat header
  // initialize from localStorage so dismissal persists across reloads
  const [showTipsBox, setShowTipsBox] = useState<boolean>(() => {
    try {
      return localStorage.getItem('uae_mt_tips_dismissed') !== 'true';
    } catch (e) {
      return true;
    }
  });
  const [dataRangeText, setDataRangeText] = useState<string>('');
  const [mainStyle, setMainStyle] = useState<React.CSSProperties | undefined>(
    undefined
  );

  const formatMonth = (ym: string) => {
    if (!ym) return '';
    const [year, month] = ym.split('_');
    const date = new Date(parseInt(year), parseInt(month) - 1);
    return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
  };

  useEffect(() => {
    // keep a local sliding window of suggestions: show first 4, queue the rest
    setVisibleSuggestions((latestSuggestions || []).slice(0, 2));
    setRemainingSuggestions((latestSuggestions || []).slice(2));
  }, [latestSuggestions]);


  useEffect(() => {
    const handleOpenAskDialogue = (payload: any) => {
      const message =
        typeof payload === 'string' ? payload : payload?.message || '';

      setIsChatPanelOpen(true);
      setIsChatPanelExpanded(false);

      if (message) {
        window.setTimeout(() => {
          try {
            eventEmitter.emit('publishMessageToInput', { message });
          } catch (_) { }
        }, 0);
      }
    };

    eventEmitter.on('openAskDialogue', handleOpenAskDialogue);

    return () => {
      eventEmitter.off('openAskDialogue', handleOpenAskDialogue);
    };
  }, []);

  const handleSuggestionClick = (s: string) => {
    try {
      eventEmitter.emit('publishMessageToInput', { message: s });
    } catch (_) { }
    callLogEvent(
      'CLICKED_ON_NEW_DAILOG_SUGGESTION',
      'Clicked on suggestion: ' + s
    );
    // remember the last suggestion used so other interactions (expand/close)
    // can include it in telemetry if needed
    try {
      setLastUsedSuggestion(s);
    } catch (_) { }
    // Immediately consume the suggestion from the visible window so it doesn't
    // show again after the user clicks it.
    setVisibleSuggestions((prevVis) => (prevVis || []).filter((v) => v !== s));

    // If we have queued suggestions, bring the next one into the visible window.
    setRemainingSuggestions((prevRem) => {
      if (prevRem && prevRem.length > 0) {
        const [next, ...rest] = prevRem;
        // Append the next suggestion into visibleSuggestions
        setVisibleSuggestions((prevVis) => {
          // ensure the clicked suggestion is not present and avoid duplicates
          const base = (prevVis || []).filter((v) => v !== s);
          // Keep visible window size reasonable (append next)
          return [...base, next];
        });
        return rest;
      }
      return prevRem;
    });
    // Clear any pending marker (we now remove immediately)
    setPendingUsedSuggestion(null);
  };

  useEffect(() => {
    let mounted = true;
    const fetchData = async () => {
      try {
        const data = await getFiltersApi();
        if (
          mounted &&
          data?.year_month &&
          Array.isArray(data.year_month) &&
          data.year_month.length > 0
        ) {
          const sorted = [...data.year_month].sort();
          const start = sorted[0];
          const end = sorted[sorted.length - 1];
          setDataRangeText(
            `(DwD uses data from ${formatMonth(start)} to ${formatMonth(end)}.)`
          );
        }
      } catch (e) {
        console.warn('Filter API failed for chat panel', e);
      }
    };
    fetchData();
    return () => {
      mounted = false;
    };
  }, []);

  // Pick a random variation set once when loading starts (used by StreamingBubble in child)
  const variationSetRef = React.useRef<string[]>([]);

  const handlePlaceHolderMessage = () => {
    const random: number = Math.floor(Math.random() * 4) + 1;
    variationSetRef.current = variationData['Variation ' + random] || ['Analyzing your query...'];
  };

  const savedPageTitle = useAppSelector((state) => state.chatBotDetails.title);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  // Treat widths between sm and md as tablet
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  useEffect(() => {
    if (isMobile) {
      setIsInsightsNavOpen(false);
    }
  }, [isMobile]);

  // When the chat panel opens (docked) we reduce the main content width by 25%
  // so it appears pushed left. When the panel is expanded we restore normal layout.
  useEffect(() => {
    if (isChatPanelOpen && !isChatPanelExpanded) {
      // On mobile we let the chat overlay full width; only shrink on larger screens
      if (!isMobile) {
        // If user resized panel, calculate main width to remaining space.
        if (chatPanelWidth && typeof chatPanelWidth === 'number') {
          const remaining = Math.max(window.innerWidth - chatPanelWidth, 0);
          setMainStyle({
            width: `${remaining}px`,
            transition: 'width 240ms ease',
          });
        } else {
          // default: reduce main content width to accommodate a 30% docked chat panel
          setMainStyle({
             width: '70%',
             transition: 'width 300ms ease' });
        }
      } else {
        setMainStyle(undefined);
      }
    } else {
      // panel closed or expanded -> reset main width
      setMainStyle(undefined);
    }
  }, [isChatPanelOpen, isChatPanelExpanded, isMobile]);

  // Initialize chatPanelWidth when panel opens (docked) so resizing starts from a sensible value
  useEffect(() => {
    if (isChatPanelOpen && !isChatPanelExpanded) {
      if (!chatPanelWidth) {
        const defaultRatio = isMobile ? 1 : 0.3; // full width on mobile, 30% on desktop/tablet
        const initial = Math.round(window.innerWidth * defaultRatio);
        setChatPanelWidth(initial);
      }
    }
    // Do not reset width when panel closes; keep last user size
  }, [isChatPanelOpen, isChatPanelExpanded, isMobile]);

  // Drag resizing handlers for the docked chat panel
  const dragRef = useRef({ dragging: false, startX: 0, startWidth: 0 });

  const onHandleMouseDown = (e: React.MouseEvent) => {
    // Only allow resizing on non-mobile
    if (isMobile) return;
    dragRef.current.dragging = true;
    dragRef.current.startX = e.clientX;
    dragRef.current.startWidth =
      chatPanelWidth || Math.round(window.innerWidth * 0.3);
    window.addEventListener('mousemove', onHandleMouseMove);
    window.addEventListener('mouseup', onHandleMouseUp);
    e.preventDefault();
  };

  const onHandleMouseMove = (e: MouseEvent) => {
    if (!dragRef.current.dragging) return;
    const dx = dragRef.current.startX - e.clientX; // moving left increases width
    let newWidth = dragRef.current.startWidth + dx;
    const minWidth = 300; // don't make the panel too small
    // Limit max width to 60% of viewport to avoid covering too much of the page
    const maxWidth = Math.floor(window.innerWidth * 0.6);
    if (newWidth < minWidth) newWidth = minWidth;
    if (newWidth > maxWidth) newWidth = maxWidth;
    setChatPanelWidth(newWidth);
    // Update main content width in sync to keep layout smooth
    setMainStyle({
      width: `${Math.max(window.innerWidth - newWidth, 0)}px`,
      transition: 'none',
    });
  };

  const onHandleMouseUp = () => {
    dragRef.current.dragging = false;
    window.removeEventListener('mousemove', onHandleMouseMove);
    window.removeEventListener('mouseup', onHandleMouseUp);
  };

  // Ensure listeners are removed if the component unmounts while dragging
  useEffect(() => {
    return () => {
      try {
        window.removeEventListener('mousemove', onHandleMouseMove);
        window.removeEventListener('mouseup', onHandleMouseUp);
      } catch (e) {
        // ignore
      }
    };
  }, []);

  // FIX: Add useEffect to restore the page title from Redux on component mount
  useEffect(() => {
    if (savedPageTitle) {
      setPageTitle(savedPageTitle);
    }
  }, [savedPageTitle]);

  // useEffect(() => {
  //     // When this component mounts (appears on screen), add the class to the body.
  //     document.body.classList.add('no-scroll');
  // 	return () => {
  //         document.body.classList.remove('no-scroll');
  //     };
  // 	}, []);
  useEffect(() => {
    // Set the header content when this component mounts
    const titleStyle: React.CSSProperties = {
      display: 'inline-block',
      marginLeft: isMobile ? '0.25rem' : isTablet ? '1.5rem' : '3rem',
      fontSize: isMobile ? '0.95rem' : isTablet ? '0.95rem' : undefined,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: isMobile ? '26vw' : isTablet ? '60vw' : 'auto',
    };

    const hasSummaryContent =
      !showDashboard && messages.some((msg: any) => msg?.sender === 'summary');

    setCenterTitle(
      <Box sx={{ display: 'flex', alignItems: 'center', gap: isMobile ? 0.55 : 1.2 }}>
        {hasSummaryContent && (
          <IconButton
            onClick={() => {
              const next = !isInsightsNavOpen;
              setIsInsightsNavOpen(next);
              callLogEvent(
                'CLICKED_HAMBURGER_MENU',
                next ? 'Insights navigation opened' : 'Insights navigation closed'
              );
              if (isMobile && next) {
                // On mobile keep only one side panel visible at a time.
                setIsChatPanelOpen(false);
                setIsPanelOpen(false);
                setIsSummaryHistoryOpen(false);
              }
            }}
            aria-label={isInsightsNavOpen ? 'close-insights-navigation' : 'open-insights-navigation'}
            sx={{
              width: isMobile ? 30 : 36,
              height: isMobile ? 30 : 36,
              borderRadius: isMobile ? '10px' : '0.75rem',
              background: '#f1f5f9',
              color: '#475569',
              border: '1px solid #e2e8f0',
              '&:hover': {
                background: '#e2e8f0',
              },
              '&:focus': {
                outline:'none',
              }
            }}
          >
            {isInsightsNavOpen ? <CloseIcon sx={{ fontSize: isMobile ? 16 : 20 }} /> : <MenuIcon sx={{ fontSize: isMobile ? 16 : 20 }} />}
          </IconButton>
        )}

        {!isMobile && (() => {
          const isKsa = secondHeaderTitle.toLowerCase().includes('ksa');
          return (
            <img
              src={isKsa ? KSAFlag : UAEFlag}
              alt='assistant-title-icon'
              style={{
                width: 40,
                height: 28,
                borderRadius: '6px',
                objectFit: isKsa ? 'contain' : 'cover',
                flexShrink: 0,
                border: '1px solid #e2e8f0',
                boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                backgroundColor: isKsa ? '#006c35' : undefined,
              }}
            />
          );
        })()}

        <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
          <Typography
            sx={{
              ...titleStyle,
              marginLeft: 0,
              fontWeight: 700,
              color: '#111827',
              lineHeight: 1.1,
            }}
            title={secondHeaderTitle}
          >
            {secondHeaderTitle}
          </Typography>
        </Box>
      </Box>
    );

    setHeaderActions(
      <Box sx={{ display: 'flex', alignItems: 'center', gap: isMobile ? 0.4 : 1, mr: isMobile ? 0.25 : 1 }}>
        {isMobile ? (
          <Tooltip title='History'>
            <IconButton
              onClick={() => {
                setIsSummaryHistoryOpen(true);
                callLogEvent('CLICKED_HISTORY', 'History panel opened (mobile)');
              }}
              aria-label='summary-history'
              sx={{
                width: 36,
                height: 36,
                borderRadius: '10px',
                color: '#425466',
                border: '1px solid #dfe7f1',
                background: '#f6f9fc',
                '&:hover': {
                  borderColor: '#c9d6e5',
                  background: '#edf3f9',
                },
              }}
            >
              <HistoryIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </Tooltip>
        ) : (
          <Button
            variant='outlined'
            onClick={() => {
              setIsSummaryHistoryOpen(true);
              callLogEvent('CLICKED_HISTORY', 'History panel opened');
            }}
            sx={{
              borderRadius: '8px',
              height: '36px',
              fontSize: '0.85rem',
              fontWeight: 500,
              textTransform: 'none',
              px: 1.8,
              color: '#425466',
              borderColor: '#dfe7f1',
              background: '#f6f9fc',
              minWidth: 'auto',
              '&:hover': {
                borderColor: '#c9d6e5',
                background: '#edf3f9',
              },
            }}
            startIcon={<HistoryIcon sx={{ fontSize: 16 }} />}
          >
            History
          </Button>
        )}

        {isMobile ? (
          <Tooltip title='Generate New Insights'>
            <IconButton
              onClick={() => {
                setIsFilterDrawerOpen(true);
                callLogEvent('CLICKED_GENERATE_INSIGHTS', 'Generate New Insights clicked (mobile)');
              }}
              aria-label='generate-new-insights'
              sx={{
                width: 36,
                height: 36,
                borderRadius: '10px',
                background: 'rgb(14, 90, 167)',
                color: '#fff',
                '&:hover': {
                  background: 'rgb(14, 90, 167)',
                },
              }}
              disabled={
                summaryToolbarState.syncFilters ||
                summaryToolbarState.isSummaryGenerating ||
                disableSummaryBtn
              }
            >
              {summaryToolbarState.syncFilters ||
              summaryToolbarState.isSummaryGenerating ||
              disableSummaryBtn ? (
                <CircularProgress size={16} disableShrink sx={{ color: 'white' }} />
              ) : (
                <FilterAltIcon sx={{ fontSize: 18 }} />
              )}
            </IconButton>
          </Tooltip>
        ) : (
          <Button
            variant='contained'
            onClick={() => {
              setIsFilterDrawerOpen(true);
              callLogEvent('CLICKED_GENERATE_INSIGHTS', 'Generate New Insights clicked');
            }}
            sx={{
              background: 'rgb(14, 90, 167)',
              borderRadius: '8px',
              height: '36px',
              fontSize: '0.85rem',
              fontWeight: 700,
              color: '#fff',
              textTransform: 'none',
              px: 2,
              '&:hover': {
                background: 'rgb(14, 90, 167)',
              },
            }}
            startIcon={<FilterAltIcon sx={{ fontSize: 16 }} />}
            disabled={
              summaryToolbarState.syncFilters ||
              summaryToolbarState.isSummaryGenerating ||
              disableSummaryBtn
            }
          >
            {summaryToolbarState.syncFilters ||
            summaryToolbarState.isSummaryGenerating ||
            disableSummaryBtn ? (
              <CircularProgress size={16} disableShrink sx={{ color: 'white' }} />
            ) : (
              'Generate New Insights'
            )}
          </Button>
        )}

        {isMobile ? (
          <Tooltip title='Return Home'>
            <IconButton
              onClick={handleResetToNewChat}
              aria-label='return-home-summary'
              sx={{
                width: 36,
                height: 36,
                borderRadius: '10px',
                background: '#005bbd',
                color: '#fff',
                '&:hover': {
                  background: '#004c9a',
                },
              }}
            >
              <HomeIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </Tooltip>
        ) : (
          <Button
            variant='outlined'
            onClick={handleResetToNewChat}
            sx={{
              borderRadius: '8px',
              height: '36px',
              fontSize: '0.85rem',
              fontWeight: 600,
              textTransform: 'none',
              px: 1.8,
              color: '#425466',
              borderColor: '#dfe7f1',
              background: '#f6f9fc',
              minWidth: 'auto',
              '&:hover': {
                borderColor: '#c9d6e5',
                background: '#edf3f9',
              },
            }}
            startIcon={<HomeIcon sx={{ fontSize: 16 }} />}
          >
            Return Home
          </Button>
        )}
      </Box>
    );

    // Clear the header content when the component unmounts
    return () => {
      setCenterTitle(null);
      setHeaderActions(null);
    };
  }, [
    isMobile,
    isTablet,
    messages,
    showDashboard,
    isInsightsNavOpen,
    summaryToolbarState.syncFilters,
    summaryToolbarState.isSummaryGenerating,
    secondHeaderTitle,
  ]);

  useEffect(() => {
    // If the component received the 'getSummary' action and has no messages yet...
    if (initialAction === 'getSummary' && messages.length === 0) {
      // ...call its own handleSummary function immediately.
      handleSummary('UAE MT');
    }
  }, [initialAction]);

  // Animation is now handled inside StreamingBubble (zero parent state updates per character).

  // 	useEffect(() => {
  //   const savedSource = sessionStorage.getItem('project_name');
  //   if (savedSource) {
  //     setCurrentDataSource(savedSource);
  //   }
  // }, []);

  // useEffect(() => {
  // 	if (localStorage.getItem('DataSource') === null) {
  // 		localStorage.setItem('DataSource', 'topline');
  // 		setCurrentDataSource('topline');
  // 	} else {
  // 		if (localStorage.getItem('DataSource') === 'r_and_d') {
  // 			if (messages.length === 0) {
  // 				setLatestSuggestions(R_AND_D_AUTO_SUGGESTIONS);
  // 				// handleSend('Hi , please ask your question or select from the suggestions below');
  // 			}
  // 		}
  // 		if (localStorage.getItem('DataSource') === 'SpendWise') {
  // 			if (messages.length === 0) {
  // 				setLatestSuggestions(SPEND_WISE_SUGGESTIONS);
  // 				// handleSend('Hi , please ask your question or select from the suggestions below');
  // 			}
  // 		}
  // 		setCurrentDataSource(localStorage.getItem('DataSource')!);
  // 	}
  // }, [messages.length]);

  interface summaryProps {
    projName: string;
    param1?: string;
    param2?: string;
    param3?: string;
    param4?: string;
    param5?: string;
    param6?: string;
    param7?: string;
    param8?: string;
    time_dimension?: string;
    email?: string;
  }

  let dispatch = useDispatch();
  let chatList = useAppSelector((state) => state.chatBotDetails.summaryInfo);

  const [disableSummaryBtn, setDisableSummaryBtn] = useState(false);

  const getSummary = async (payload: summaryProps) => {
    try {
      const updatedSuggesstions = TOPLINE_AUTO_SUGGESTIONS_WHAT_UAE_MT;
      setLatestSuggestions(updatedSuggesstions);
      const startTime = Date.now();
      const reqId = uuidv4();
      const response = await getlatestSummary(payload);
      // console.log("Summary API response:", response);
      const taskId = response?.taskid || response?.task_id || null;
      console.log(response)
      // console.log("Extracted taskId:", taskId);
      // console.log('response from summary', response.result.summary);
      // const response = payload.projName.trim()=="FLNA Topline"?await getlatestSummary(payload):uaeResponse2;
      if (
        response &&
        response.result.summary &&
        response?.result.summary['business_analyst']
      ) {
        const endTime = Date.now();
        const summaryInfo = response?.result.summary['business_analyst'];
        const treeInfo = response?.result.summary['tree'];
        const TaskID = response?.task_id ?? 'null';
        console.log('TaskID', TaskID);
        const responses: any = [];
        const summaryWithTask = `${summaryInfo.substring(
          0,
          500
        )}\n\nTask ID: ${TaskID}`;
        // console.log("Filters", Filter);
        saveChatHistory({
          question: "Generate Summary",
          answer: summaryWithTask,
          // answer: TaskID,
          // Taskid: TaskID,
          Filters: Filter,
          email: currentUserEmail,
          images: JSON.stringify([]),
          agent_metadata: JSON.stringify([]),
          response_time_in_seconds: getSeconds(startTime, endTime),
          request_id: reqId,
        });

        let imgArr: any = response.result.summary.images || {};
        let chartInsightsData: any = response.result.summary.chart_insights || {};
        const summaryFiles: any = response?.result?.summary?.files || {};
        const isPresentationDeckFilePayload = (item: any) =>
          item &&
          typeof item === 'object' &&
          item.data &&
          (item.filename || item.file_extension);

        // Keep backward compatibility: extract files from old payload structure if needed
        let cleanedFiles: any = { ...summaryFiles };
        Object.keys(cleanedFiles).forEach((key) => {
          if (Array.isArray(cleanedFiles[key])) {
            const fileItems = cleanedFiles[key].filter(isPresentationDeckFilePayload);
            if (fileItems.length > 0) {
              cleanedFiles[key] = fileItems;
            } else {
              delete cleanedFiles[key];
            }
          } else {
            delete cleanedFiles[key];
          }
        });

        // Backward compatibility for old mixed payloads where files were under images
        Object.keys(imgArr).forEach((key) => {
          if (!cleanedFiles[key] && Array.isArray(imgArr[key])) {
            const fileItems = imgArr[key].filter(isPresentationDeckFilePayload);
            const imageItems = imgArr[key].filter(
              (item: any) => !isPresentationDeckFilePayload(item)
            );
            if (fileItems.length > 0) {
              cleanedFiles[key] = fileItems;
            }
            if (imageItems.length > 0) {
              imgArr[key] = imageItems;
            } else {
              delete imgArr[key];
            }
          }
        })
        console.log('imgArr', imgArr);
        responses.push(
          // { sender: 123, chatMessage: "Generate Summary", images: [] },
          {
            chatId: reqId,
            request_id: reqId,
            sender: 'summary',
            chatMessage: summaryInfo,
            Taskid: response?.task_id,
            images: imgArr,
            chart_insights: chartInsightsData,
            files: cleanedFiles,
            treeInfo: treeInfo ? JSON.stringify(treeInfo) : null,
            content: '',
            suggestions: updatedSuggesstions,
            is_liked: false,
            is_disliked: false,
            is_saved: false,
            response_time_in_seconds: getSeconds(startTime, endTime),
            isError: false,
            timestamp: new Date(),
          }
        );
        // console.log("response", response);

        setMessages((prevMessages: any[]) => {
          const updated = [...prevMessages, ...responses];
          // localStorage.setItem("lastChatHistory", JSON.stringify(updated));
          dispatch(updateSummary(JSON.stringify(updated)));
          dispatch(updateTreeInfo(JSON.stringify(treeInfo)));
          return updated;
        });
      }
      return response;
    } catch (error) {
      console.error('Error generating summary:', error);
      const errorMsg = {
        sender: 'summary',
        chatMessage:
          'Sorry, there was an error generating the summary. Please try again after refreshing the page.',
        isError: true,
      } as any;
      setMessages((prevMessages: any[]) => {
        const updated = [...prevMessages, errorMsg];
        dispatch(updateSummary(JSON.stringify(updated)));
        return updated;
      });
    } finally {
      setIsIdeal(true);
      setDisableSummaryBtn(false);
    }
  };

  useEffect(() => {
    if (messages.length === 0 && chatList && JSON.parse(chatList!).length > 0) {
      const lastChatHistory = JSON.parse(chatList!);
      const responses: any = [];
      lastChatHistory!.forEach((item: any) => {
        responses.push({
          chatId: item.chatId,
          request_id: item.request_id,
          sender: item.sender,
          chatMessage:
            item.sender === 123 || item.sender === 'summary'
              ? item.chatMessage
              : genereateGridRow(item.content),
          images:
            Array.isArray(item.images) && item.images.length > 0
              ? getImageBox(item.images)
              : [],
          content: item.content,
          question: item.question,
          suggestions: item.suggestions,
          is_liked: item.is_liked,
          is_disliked: item.is_disliked,
          response_time_in_seconds: item.response_time_in_seconds,
          is_saved: item.is_saved,
          agent_metadata: item['agent_metadata'],
          isError: item.isError,
          hash: item?.hash ? item?.hash : '',
        });
      });
      setMessages(responses);
      stateRef.current = responses;
    } else {
      handleMessages(messages);
    }
  }, [messages]);

  const removeFirstElement = (element: any, index: number) => {
    return index > 0;
  };

  const getChatResp = async (question: any, oldMessages: any) => {
    const startTime = Date.now();
    const reqId = uuidv4();
    setRequestId(reqId);
    let data = authState?.idToken?.claims;
    // Sanitize agent_metadata to remove SQL code only for UAE MT datasource.
    const sanitizeAgentMetadata = (agentMeta: any) => {
      try {
        // If it's a JSON string, parse it
        let obj = agentMeta;
        if (typeof agentMeta === 'string') {
          try {
            obj = JSON.parse(agentMeta);
          } catch (e) {
            // keep as string
          }
        }

        const removeSqlFromString = (s: string) => {
          if (!s || typeof s !== 'string') return s;
          // remove fenced sql code blocks: ```sql ... ```
          s = s.replace(/```sql[\s\S]*?```/gi, '');
          // remove any lines that look like SQL statements (SELECT/INSERT/UPDATE/DELETE/CREATE/DROP)
          s = s
            .split('\n')
            .filter(
              (ln) =>
                !/\b(select|insert|update|delete|create|drop|from|where)\b/i.test(
                  ln
                )
            )
            .join('\n');
          return s.trim();
        };

        if (typeof obj === 'string') {
          return removeSqlFromString(obj);
        }

        if (obj && typeof obj === 'object') {
          const cloned: any = Array.isArray(obj) ? [] : {};
          for (const k in obj) {
            if (!Object.prototype.hasOwnProperty.call(obj, k)) continue;
            const v = obj[k];
            // remove keys that include 'sql' in the key name
            if (/sql/i.test(k)) continue;
            if (typeof v === 'string') {
              cloned[k] = removeSqlFromString(v);
            } else if (typeof v === 'object') {
              cloned[k] = sanitizeAgentMetadata(JSON.stringify(v));
              try {
                // if returned as string try parse back
                cloned[k] = JSON.parse(cloned[k]);
              } catch (e) {
                // leave as-is
              }
            } else {
              cloned[k] = v;
            }
          }
          return cloned;
        }
        return agentMeta;
      } catch (e) {
        return agentMeta;
      }
    };

    const getSanitizedContext = (ctx: any[]) => {
      if (!ctx || !Array.isArray(ctx)) return ctx;
      // Only sanitize when datasource is uae_mt (uses outer isUaeMt flag)
      return ctx.map((item) => {
        if (!isUaeMt) return item;
        try {
          if (!item || typeof item !== 'object') return item;
          const cloned = { ...item } as any;
          if (
            cloned.agent_metadata !== undefined &&
            cloned.agent_metadata !== null
          ) {
            cloned.agent_metadata = sanitizeAgentMetadata(
              cloned.agent_metadata
            );
          }
          return cloned;
        } catch (e) {
          return item;
        }
      });
    };

    const payload = {
      request_id: reqId,
      old_dialog: false,
      message: question,
      threadID1: threadId1,
      threadID2: threadId2,
      persona_name: 'leadership',
      // project_name: currentDataSource,
      project_name: localStorage.getItem('DataSource'),
      email: currentUserEmail,
      docfile_id: attachmentId,
      context: getSanitizedContext(
        sessionContext.length > 5
          ? sessionContext.filter(removeFirstElement)
          : sessionContext
      ),
      query_analyser:
        queryAnalyser.length > 5
          ? queryAnalyser.filter(removeFirstElement)
          : queryAnalyser,
    };
    const source: any = axios.CancelToken.source();
    // Create a cancel token
    setCancelTokenSource(source);
    const lastChatHistory = [...oldMessages];
    const responses: any = [];
    const payloadWithMarket = appendMarketIfNeeded(payload);
    //URL Changing based on the project name
    const url = getApplicationUrl(localStorage.getItem('DataSource'));
    await axios
      .post(url + '/api/chat', payloadWithMarket, {
        cancelToken: source.token,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('accessToken')!}`,
        },
      })
      .then((res: any) => {
        const response = res?.data;
        const endTime = Date.now();
        setThreadId1(response?.threadID1);
        setThreadId2(response?.threadID2);

        if (response?.success) {
          let QueryAnalyser = '';
          response?.responses?.forEach((item: any, itemIndex: number) => {
            if (item['Query Analyser'] && item['Query Analyser'] !== '') {
              QueryAnalyser = item['Query Analyser'];
              setQueryAnalyser([...queryAnalyser, QueryAnalyser]);
            }
            if (item['Response Synthesizer Agent']) {
              item['Query Analyser'] = QueryAnalyser;
              setSessionContext([...sessionContext, item]);
              const finalResponse = item["Response Synthesizer Agent"];
              saveChatHistory({
                question: question,
                answer: finalResponse,
                images: JSON.stringify(response?.images),
                agent_metadata: JSON.stringify(item["agent_metadata"]),
                email: currentUserEmail,
                response_time_in_seconds: getSeconds(startTime, endTime),
                hash: response?.hash ? response?.hash : "",
                request_id: reqId,
              });
              lastChatHistory.push({
                request_id: reqId,
                chatId: reqId,
                sender: 415,
                chatMessage: finalResponse,
                images: response?.images,
                content: finalResponse,
                question: question,
                suggestions: latestSuggestions,
                is_liked: false,
                is_disliked: false,
                is_saved: false,
                response_time_in_seconds: getSeconds(startTime, endTime),
                agent_metadata: item['agent_metadata1'],
                isError: false,
                QueryAnalyser: QueryAnalyser,
                hash: response?.hash ? response?.hash : '',
              });
              responses.push({
                request_id: reqId,
                chatId: reqId,
                sender: 415,
                chatMessage: genereateGridRow(finalResponse),
                images:
                  Array.isArray(response?.images) && response?.images.length > 0
                    ? getImageBox(response?.images)
                    : [],
                content: finalResponse,
                question: question,
                suggestions: latestSuggestions,
                is_liked: false,
                is_disliked: false,
                is_saved: false,
                response_time_in_seconds: getSeconds(startTime, endTime),
                agent_metadata: item['agent_metadata'],
                isError: false,
                QueryAnalyser: QueryAnalyser,
                hash: response?.hash ? response?.hash : '',
              });
              // localStorage.setItem(
              //   "lastChatHistory",
              //   JSON.stringify(lastChatHistory)
              // );
              dispatch(updateSummary(JSON.stringify(lastChatHistory)));
              setMessages([...oldMessages, ...responses]);
              setIsIdeal(true);
            }
          });
        }
      })
      .catch(async (err) => {
        console.log('ERROR::::', err);
        const endTime = Date.now();
        if (axios.isCancel(err)) {
          console.log('REQUEST CANCELLED:', err.message);
        }
        if (err && err.response && err.response.data) {
          const response = err.response.data;
          saveChatHistory({
            question: question,
            answer: response?.error,
            email: currentUserEmail,
            images: JSON.stringify([]),
            agent_metadata: JSON.stringify([]),
            response_time_in_seconds: getSeconds(startTime, endTime),
            request_id: reqId,
          });
          lastChatHistory.push({
            request_id: reqId,
            chatId: reqId,
            sender: 415,
            chatMessage: response?.error,
            images: [],
            content: response?.error,
            question: question,
            suggestions: latestSuggestions,
            is_liked: false,
            is_disliked: false,
            is_saved: false,
            errorStatus: err.response.status,
            response_time_in_seconds: getSeconds(startTime, endTime),
            isError: true,
            hash: response?.hash ? response?.hash : '',
          });
          responses.push({
            request_id: reqId,
            chatId: reqId,
            sender: 415,
            chatMessage: response?.error,
            images: [],
            content: response?.error,
            question: question,
            suggestions: latestSuggestions,
            is_liked: false,
            is_disliked: false,
            is_saved: false,
            errorStatus: err.response.status,
            response_time_in_seconds: getSeconds(startTime, endTime),
            isError: true,
            hash: response?.hash ? response?.hash : '',
          });
        }
        // localStorage.setItem(
        //   "lastChatHistory",
        //   JSON.stringify(lastChatHistory)
        // );
        dispatch(updateSummary(JSON.stringify(lastChatHistory)));
        setMessages([...oldMessages, ...responses]);
        setIsIdeal(true);
      });
  };
  const clearAllRecentQueries = async () => {
    setLoading(true);
    const response = await deleteRecentQueries({
      email: currentUserEmail,
    });
    console.log("delete recent queries::", response);
    const result = await getChatHistory(currentUserEmail!);
    if (result && result.length > 0) {
      setChatHistory(result);
    } else {
      setChatHistory([]);
    }
    setLoading(false);
    callLogEvent(
      "CLICKED_ON_NEW_DAILOG_RECENT_SEARCHES_CLEAR_ALL_BUTTON",
      "clicked on CLEAR ALL button to clear the recent searches"
    );
  };
  const getImageBox = (data: string[]) => {
    return (
      <div className='wordwrap display-grid-template-columns'>
        {data &&
          data.length !== 0 &&
          data.map((img: any, imgIndex: number) => {
            return (
              <div key={imgIndex}>
                <img
                  src={`data:image/png;base64,${img}`}
                  className='chatImageSize'
                  // style={{height:"300px",width:"300px"}}
                  alt={
                    img.section_name
                      ? img.section_name
                      : 'reponse image' + imgIndex
                  }
                />
                <br />
              </div>
            );
          })}
      </div>
    );
  };

  const genereateGridRow = (dataContent: string) => {
    if (!dataContent) return <span>No data found</span>;

    const data = dataContent
      .replace('| sender: Response Synthesizer Agent', '')
      .replace(
        'sender: Text-to-SQL Agent" additional_kwargs={} response_metadata={}',
        ''
      )
      .replace(
        "sender: Text-to-SQL Agent' additional_kwargs={} response_metadata={}",
        ''
      )
      .replace(
        "sender: Analyst Agent' additional_kwargs={} response_metadata={}",
        ''
      )
      .replace('/\n\n(.*?)\n\n1/g', '\n$1')
      .replace(CONTENT_REGEX_TWO, '')
      .replace(CONTENT_REGEX, '');

    let isHeaderRow = true;

    // Collect rows into a table structure for proper scrollable rendering
    const lines = data?.split('\n') || [];
    const tableRows: Array<string[]> = [];
    const nonTableParts: Array<{ type: 'heading' | 'text'; content: string; index: number }> = [];
    let inTable = false;
    let tableStartIndex = -1;
    const tableSections: Array<{ startIndex: number; rows: Array<string[]> }> = [];

    lines.forEach((item: string, idx: number) => {
      if (item.includes('-----')) return; // separator line
      if (item.includes('|')) {
        if (!inTable) {
          inTable = true;
          tableStartIndex = idx;
          tableSections.push({ startIndex: idx, rows: [] });
        }
        const parts = item.split('|');
        const cells = parts.slice(1, parts.length - 1).map((cell: string) =>
          cell.replace(/\*\*(.*?)\*\*/g, '$1').replace(/\*(.*?)\*/g, '$1').replace(/`(.*?)`/g, '$1').trim()
        );
        if (cells.length > 0) {
          tableSections[tableSections.length - 1].rows.push(cells);
        }
      } else {
        inTable = false;
        if (item.includes('###')) {
          nonTableParts.push({ type: 'heading', content: item.replace('###', ''), index: idx });
        } else if (item.trim()) {
          nonTableParts.push({ type: 'text', content: item, index: idx });
        }
      }
    });

    // Build render order by index
    type RenderItem = { index: number; element: React.ReactNode };
    const renderItems: RenderItem[] = [];

    nonTableParts.forEach((part) => {
      if (part.type === 'heading') {
        renderItems.push({
          index: part.index,
          element: (
            <span key={`h-${part.index}`}>
              <br />
              <h4 style={{ fontWeight: 700 }}>{part.content}</h4>
            </span>
          ),
        });
      } else {
        renderItems.push({
          index: part.index,
          element: (
            <span key={`t-${part.index}`}>
              <span
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(
                    '<span>' +
                    (part.content.includes('**')
                      ? part.content.replace(/\\(.?)\\*/g, '<b>$1</b>')
                      : part.content) +
                    '</span>'
                  ),
                }}
              />
              <br />
            </span>
          ),
        });
      }
    });

    tableSections.forEach((section) => {
      if (section.rows.length === 0) return;
      const headerCells = section.rows[0];
      const bodyRows = section.rows.slice(1);
      renderItems.push({
        index: section.startIndex,
        element: (
          <div
            key={`table-${section.startIndex}`}
            style={{
              overflowX: 'auto',
              WebkitOverflowScrolling: 'touch',
              margin: '8px 0',
              border: '1px solid #e0e0e0',
              borderRadius: '4px',
            }}
          >
            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
              }}
            >
              <thead>
                <tr>
                  {headerCells.map((cell: string, ci: number) => (
                    <th
                      key={ci}
                      style={{
                        border: '1px solid #e0e0e0',
                        padding: '6px 8px',
                        fontWeight: 700,
                        whiteSpace: 'nowrap',
                        fontSize: '12px',
                        backgroundColor: '#f5f5f5',
                      }}
                    >
                      {cell}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {bodyRows.map((row: string[], ri: number) => (
                  <tr key={ri}>
                    {row.map((cell: string, ci: number) => (
                      <td
                        key={ci}
                        style={{
                          border: '1px solid #e0e0e0',
                          padding: '6px 8px',
                          whiteSpace: 'nowrap',
                          fontSize: '12px',
                        }}
                      >
                        {cell}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ),
      });
    });

    renderItems.sort((a, b) => a.index - b.index);

    return (
      <div>
        {renderItems.map((item) => item.element)}
      </div>
    );
  };

  const handleSend = (message: any) => {
    callLogEvent(
      'CLICKED_ON_NEW_DAILOG_CHATBOX_SEND_BUTTON',
      'Clicked to send text to AI with text: ' + message
    );
    setIsIdeal(false);
    // Clear all dialog cues/suggestions when the user actually sends a message.
    // This removes both visible and remaining suggestions so the Dialog Cues
    // area disappears after the user uses the chat (covers typed or clicked suggestions).
    try {
      setVisibleSuggestions([]);
      setRemainingSuggestions([]);
      setPendingUsedSuggestion(null);
    } catch (e) {
      // defensive: ignore state update errors
    }
    setMessages([...messages, { sender: 123, chatMessage: message, images: [] }]);
    setIsMessageSent(true);
    setLoading(true);
    handlePlaceHolderMessage();
    getChatResp(message, [
      ...messages,
      { sender: 123, chatMessage: message, images: [] },
    ]);
    setChatHistory([...chatHistory, message]);
  };

  const cancelRequest = () => {
    if (cancelTokenSource) {
      console.log('API KILLED');
      cancelTokenSource.cancel('Request was canceled by the user.');
    }
  };

  const handleResetToNewChat = () => {
    console.log('cancelled requestid', requestId);
    setLatestSuggestions(TOPLINE_AUTO_SUGGESTIONS_WHAT_UAE_MT);
    cancelRequest();
    setMessages([]);
    setIsMessageSent(false);
    setIsIdeal(true);
    setThreadId1('');
    setThreadId2('');
    setSessionContext([]);
    setQueryAnalyser([]);
    setInputValue('');
    onReset();
    // localStorage.setItem("lastChatHistory", "");
    dispatch(updateSummary(''));
    setShowDashboard(false);
    setAttachmentId('');
    callLogEvent(
      'CLICKED_ON_NEW_DAILOG_NEW_CHAT_BUTTON',
      'clicked on NEW CHAT button to initialize a new chat session'
    );
    setDisableSummaryBtn(false);
    // localStorage.removeItem('DataSource'); // This is crucial
    // window.location.reload();
    onReset();
  };

  const clearChatHistory = () => {
    // Only clear visible chat QA messages while preserving page state
    // Filter out the actual chat messages (QA pairs) but keep any summary/system messages
    const clearedMessages = messages.filter(
      (msg: any) => msg?.sender === 'summary' || msg?.sender === '_hidden'
    );

    // Update in-memory messages and Redux summary to keep UI consistent
    setMessages(clearedMessages);
    dispatch(updateSummary(JSON.stringify(clearedMessages)));

    // Update persisted lastChatHistory to remove QA pairs but keep summaries
    try {
      const lastChat = localStorage.getItem('lastChatHistory');
      if (lastChat) {
        const parsed = JSON.parse(lastChat);
        const filtered = parsed.filter(
          (msg: any) => msg?.sender === 'summary' || msg?.sender === '_hidden'
        );
        safeSetLastChatHistory(filtered);
      }
    } catch (e) {
      // Ignore storage errors
    }

    // Restore the suggestion window so dialog cues reappear after clearing
    try {
      const resetSuggestions = TOPLINE_AUTO_SUGGESTIONS_WHAT_UAE_MT || [];
      setLatestSuggestions(resetSuggestions);
      setVisibleSuggestions((resetSuggestions || []).slice(0, 2));
      setRemainingSuggestions((resetSuggestions || []).slice(2));
      setPendingUsedSuggestion(null);
      setLastUsedSuggestion(null);
    } catch (e) {
      // defensive: ignore suggestion state errors
    }

    callLogEvent(
      'CLICKED_ON_NEW_DAILOG_CLEAR_CHAT_BUTTON',
      'User cleared chat messages using header + button'
    );
  };
  const handleMessages = (updatedMessages: any) => {
    setMessages(updatedMessages);
    // localStorage.setItem("lastChatHistory", JSON.stringify(updatedMessages));
    dispatch(updateSummary(JSON.stringify(updatedMessages)));
  };

  const safeSetLastChatHistory = (arr: any[]) => {
    // If payload is very large (images or long content), try saving a compacted version first
    try {
      const jsonPreview = JSON.stringify(arr);
      const SIZE_THRESHOLD = 200 * 1024; // 200 KB
      if (jsonPreview.length > SIZE_THRESHOLD) {
        try {
          const compact = (Array.isArray(arr) ? arr : []).map((m: any) => {
            const copy: any = { ...m };
            // remove heavy fields that commonly blow up storage (images/content)
            if (copy.images) delete copy.images;
            if (copy.content) delete copy.content;
            if (copy.response) delete copy.response;
            return copy;
          });
          localStorage.setItem('lastChatHistory', JSON.stringify(compact));
          return;
        } catch (eCompact) {
          // fall through to normal attempt
        }
      }

      // Normal attempt: store full payload
      localStorage.setItem('lastChatHistory', jsonPreview);
      return;
    } catch (err: any) {
      // Handle quota exceeded errors by attempting to store a trimmed or metadata-only version
      try {
        const isQuotaError =
          err &&
          (err.name === 'QuotaExceededError' ||
            err.name === 'NS_ERROR_DOM_QUOTA_REACHED' ||
            err.code === 22);
        if (isQuotaError) {
          // keep only the most recent 50 messages to reduce size
          const trimmed = Array.isArray(arr) ? arr.slice(-50) : arr;
          localStorage.setItem('lastChatHistory', JSON.stringify(trimmed));
          return;
        }
      } catch (e2) {
        // fall through to metadata-only attempt
      }

      try {
        // As a last resort, save a much smaller metadata-only payload for recovery
        const meta = (Array.isArray(arr) ? arr.slice(-50) : []).map(
          (m: any) => ({
            chatId: m?.chatId ?? null,
            sender: m?.sender ?? null,
            chatMessage:
              typeof m?.chatMessage === 'string'
                ? m.chatMessage.slice(0, 200)
                : '',
            timestamp: m?.timestamp ?? null,
          })
        );
        localStorage.setItem('lastChatHistory', JSON.stringify(meta));
        return;
      } catch (e3) {
        // give up silently but log for diagnostics
        // eslint-disable-next-line no-console
        console.warn(
          'Failed to persist lastChatHistory due to storage quota',
          e3
        );
      }
    }
  };

  const handleSummary = async (projName: string) => {
    const selectedMarket = localStorage.getItem('SelectedMarket') || 'UAE MT';

    // Start loading state immediately
    setLoading(true);
    setIsIdeal(false);
    setDisableSummaryBtn(true);

    setPageTitle(selectedMarket);
    dispatch(updateTitle(selectedMarket));

    // Function to get default year/month (current - 3 months)
    const getDefaultYearMonth = () => {
      let defaultYear = new Date().getFullYear();
      let defaultMonth = new Date().getMonth() + 1; // convert to 1-12

      // Subtract 3 from month and handle year rollover
      if (defaultMonth <= 3) {
        // Jan, Feb, or March
        defaultMonth = defaultMonth + 9; // becomes Oct, Nov, or Dec
        defaultYear -= 1;
      } else {
        defaultMonth -= 3;
      }

      return { defaultYear, defaultMonth };
    };

    // First try to get filters from API. If API fails, do not send default filters.
    let filterYear: number | undefined, filterMonth: number | undefined;
    let filtersAvailable = false;
    // containers for region/retailer values returned by the API (if any)
    let availableRegions: string[] = [];
    let availableRetailers: string[] = [];
    let availableCategories: string[] = [];
    try {
      const data = await getFiltersApi();
      if (
        data.year_month &&
        Array.isArray(data.year_month) &&
        data.year_month.length > 0
      ) {
        // Sort year_month entries to get the latest one
        const sortedYearMonths = [...data.year_month].sort((a, b) => {
          const [yearA, monthA] = a.split('_').map(Number);
          const [yearB, monthB] = b.split('_').map(Number);
          if (yearA !== yearB) return yearB - yearA;
          return monthB - monthA;
        });

        // Get the latest year_month (first after sorting)
        const [apiYear, apiMonth] = sortedYearMonths[0].split('_').map(Number);
        filterYear = apiYear;
        filterMonth = apiMonth;

        if (
          data?.combinations?.retailer &&
          Array.isArray(data.combinations.retailer)
        ) {
          availableRetailers = data.combinations.retailer;
        }

        if (
          data?.category_combinations &&
          Array.isArray(data.category_combinations)
        ) {
          availableCategories = Array.from(
            new Set(
              data.category_combinations
                .map((item: any) => String(item?.category || '').trim())
                .filter((item: string) => item.length > 0)
            )
          );
        }

        if (!availableCategories.length) {
          const rawCategories =
            (data as any)?.Category ?? (data as any)?.category ?? null;

          if (Array.isArray(rawCategories)) {
            availableCategories = rawCategories
              .map((item: any) => String(item || '').trim())
              .filter((item: string) => item.length > 0);
          } else if (rawCategories && typeof rawCategories === 'object') {
            availableCategories = Object.entries(rawCategories)
              .filter(([key]) => String(key).toUpperCase() !== 'ALL')
              .map(([, value]) => String(value || '').trim())
              .filter((item) => item.length > 0);
          }
        }

        filtersAvailable = true;
      } else {
        throw new Error('No valid year_month data from API');
      }
    } catch (err) {
      console.warn(
        'UAE MT filters API failed, skipping filters in request:',
        err
      );
      filtersAvailable = false;
    }
    const pad = (n: number) => String(n).padStart(2, '0');
    const makeMonthStr = (y: number, m: number) => `${y}_${pad(m)}`;

    const latestYear = filterYear as number;
    const latestMonth = filterMonth as number;

    // comp_start = latest month
    const compStartYear = latestYear;
    const compStartMonth = latestMonth;

    // comp_end = next month after latest
    const compEndDate = new Date(latestYear, latestMonth - 1);
    compEndDate.setMonth(compEndDate.getMonth() + 1);
    const compEndYear = compEndDate.getFullYear();
    const compEndMonth = compEndDate.getMonth() + 1;

    // base window = comp window shifted one year earlier
    const baseStartYear = compStartYear - 1;
    const baseStartMonth = compStartMonth;
    const baseEndYear = compEndYear - 1;
    const baseEndMonth = compEndMonth;

    let filters = {
      base_start_month: makeMonthStr(baseStartYear, baseStartMonth),
      base_end_month: makeMonthStr(baseEndYear, baseEndMonth),
      comp_start_month: makeMonthStr(compStartYear, compStartMonth),
      comp_end_month: makeMonthStr(compEndYear, compEndMonth),
      // send region/retailer as semicolon-delimited strings in the default payload
      region: '',
      sub_region: '',
      retailer: availableRetailers.join(';'),
      city: '',
      category: availableCategories.join(';'),
      subCategory: '',
      use_cache: 'true',
      manufacturer: '',
      brand: '',
      sub_brand: '',
      channel: '',
      retailer_store: '',
      promo_flag: '',
      pack_group: '',
      pack_size_group: '',
      price_point: '',
    };

    // Only include filters in the request when filters were successfully retrieved from the API
    let req: summaryProps = {
      projName: selectedMarket,
      time_dimension: 'L1W',
      email: currentUserEmail!,
      ...(
        ['UAE MT', 'KSA MT'].includes(selectedMarket) && filtersAvailable
          ? { filters: filters }
          : {}
      ),
    };
    getSummary(req);
  };

  const handleSummary2 = async (payload: any) => {
    // console.log('payload for summary: ', payload);
     const updatedPayload = {
        ...payload,
        email: currentUserEmail!
    };
    // console.log('updatedPayload for summary: ', updatedPayload);
    return await getSummary(updatedPayload);
    // const updatedPayload = {
    //     ...payload,
    //     projName: pageTitle
    // };
    // console.log('updatedPayload for summary: ', updatedPayload);
    // await getSummary(updatedPayload);
  };

  const handleDashboardClick = (projName: string, url: string) => {
    setPageTitle(projName);
    setDashboardURL(url);
    setShowDashboard(true);
  };
  const showRecentQueries = () => {
    // Directly open the side panel and load recent queries
    setIsPanelOpen(true);
    setLoading(true);
    getChatHistory(currentUserEmail!)
      .then((result) => {
        if (result && result.length > 0) {
          setChatHistory(result);
        } else {
          setChatHistory([]);
        }
      })
      .catch((e) => {
        console.error('Failed to load recent queries:', e);
        setChatHistory([]);
      })
      .finally(() => {
        setLoading(false);
      });
    callLogEvent(
      'CLICKED_ON_NEW_DAILOG_RECENT_QUERIES_BUTTON',
      'User clicked Recent Queries in UAE MT'
    );
  };

  const togglePanel = async () => {
    // compute the new open state deterministically to avoid stale setState toggles
    const newOpen = !isPanelOpen;
    setIsPanelOpen(newOpen);

    // Only load history when opening the panel
    if (newOpen) {
      try {
        setLoading(true);
        const result = await getChatHistory(currentUserEmail!);
        setChatHistory([]);
      } finally {
        setLoading(false);
      }
    }
  };

  const getRecentQueryDetails = (selectedHistory: any) => {
    callLogEvent(
      'CLICKED_ON_NEW_DAILOG_RECENT_QUERIES_QUESTION',
      'clicked on one of the query from recent queries: ' +
      selectedHistory.question
    );

    const safeParse = (val: any) => {
      if (val === null || val === undefined) return val;
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch (e) {
          // Not valid JSON, return original string
          console.warn(
            'safeParse: value is string but not JSON, returning original',
            e
          );
          return val;
        }
      }
      // Already an object/array or other primitive
      return val;
    };

    selectedHistory['agent_metadata'] = safeParse(
      selectedHistory['agent_metadata']
    );
    selectedHistory['images'] = safeParse(selectedHistory['images']);

    const formattedObjResponse = [
      { sender: 123, chatMessage: selectedHistory.question, images: [] },
      {
        chatId: selectedHistory.id!,
        sender: 415,
        chatMessage: genereateGridRow(selectedHistory.answer),
        images:
          Array.isArray(selectedHistory.images) &&
            selectedHistory.images.length > 0
            ? getImageBox(selectedHistory.images)
            : [],
        content: selectedHistory.answer,
        question: selectedHistory.question,
        suggestions: latestSuggestions,
        is_liked: selectedHistory.is_liked,
        is_disliked: selectedHistory.is_disliked,
        is_saved: selectedHistory.is_saved,
        response_time_in_seconds: selectedHistory.response_time_in_seconds,
        agent_metadata: selectedHistory['agent_metadata'],
        isError: false,
      },
    ];
    const finalResponse = [...messages, ...formattedObjResponse];
    setMessages(finalResponse);
    safeSetLastChatHistory(finalResponse);
    dispatch(updateSummary(JSON.stringify(finalResponse)));
  };

  // Helper to extract preview text from message
  const getMessageContent = (message: any): string => {
    try {
      const raw = message?.chatMessage || '';
      const lines = raw
        .split('\n')
        .map((l: string) => l.trim())
        .filter((l: string) => l);
      let content = '';
      if (lines.length >= 2) {
        content = `${lines[0]}\n${lines[1]}`;
      } else if (lines.length === 1) {
        content = lines[0];
      } else {
        content = raw.slice(0, 300);
      }
      // Remove HTML tags
      content = content.replace(/<[^>]*>/g, '');
      return content;
    } catch (e) {
      return '';
    }
  };

  // Helper to extract filter info from message
  const getFilterInfo = (message: any): string => {
    try {
      const filters: string[] = [];
      if (message?.filters && typeof message.filters === 'object') {
        Object.entries(message.filters).forEach(
          ([key, value]: [string, any]) => {
            if (value && (Array.isArray(value) ? value.length > 0 : true)) {
              filters.push(
                `${key}:${Array.isArray(value) ? value.join(',') : value}`
              );
            }
          }
        );
      }
      return filters.slice(0, 3).join('|') || 'no-filters';
    } catch (e) {
      return 'no-filters';
    }
  };

  // Handlers for pin/delete that work on the full messages array
  const handlePinToggle = (requestId: string, isPinned: boolean) => {
    try {
      const updated = [...messages];
      const actualIndex = updated.findIndex(
        (msg: any) => msg?.request_id === requestId
      );
      if (actualIndex === -1) {
        console.warn('Message not found for pin toggle');
        return;
      }

      const current = updated[actualIndex];
      const messageContent = getMessageContent(current);
      const filterInfo = getFilterInfo(current);
      const action = isPinned ? 'PIN' : 'UNPIN';

      // Log the event with message content and filters
      callLogEvent(
        `MESSAGE_${action}_CLICKED`,
        `User ${action} message - Content: ${messageContent} | Filters: ${filterInfo}`
      );

      current.is_pinned = isPinned;

      if (isPinned) {
        // Move pinned item to beginning
        updated.splice(actualIndex, 1);
        updated.unshift(current);
      } else {
        // Unpin: keep in current position
        updated[actualIndex] = current;
      }

      setMessages(updated);
      dispatch(updateSummary(JSON.stringify(updated)));
    } catch (e) {
      console.error('Failed to toggle pin', e);
    }
  };

  const handleDeleteSummary = (requestId: string) => {
    try {
      const updated = [...messages];
      const actualIndex = updated.findIndex(
        (msg: any) => msg?.request_id === requestId
      );
      if (actualIndex === -1) {
        console.warn('Message not found for delete');
        return;
      }

      const current = updated[actualIndex];
      const messageContent = getMessageContent(current);
      const filterInfo = getFilterInfo(current);

      // Log the delete event with message content and filters (only log once here)
      callLogEvent(
        'MESSAGE_DELETE_CLICKED',
        `User deleted message - Content: ${messageContent}`
      );

      if (updated.length === 1) {
        updated[0] = { sender: '_hidden' };
      } else {
        updated.splice(actualIndex, 1);
      }

      setMessages(updated);
      dispatch(updateSummary(JSON.stringify(updated)));
    } catch (e) {
      console.error('Failed to delete summary', e);
    }
  };

  const summaryMessages = (messages || []).filter(
    (msg: any) => msg?.sender === 'summary' || msg?.sender === '_hidden'
  );
  const qaMessages = (messages || []).filter(
    (msg: any) => msg?.sender !== 'summary' && msg?.sender !== '_hidden'
  );

  const activeSectionFiles = React.useMemo(() => {
    const allFiles = summaryContext.activeSummaryMessage?.files || {};
    if (!Object.keys(allFiles).length) return [];

    const markdown = String(summaryContext.activeSummaryMessage?.chatMessage || '');
    const activeSection = String(summaryContext.activeInsightSection || '').toUpperCase().trim();

    // Parse the markdown to build a map: normalized section label → img alt keys found in that section.
    // The <details><summary>Section Name</summary>...<img alt="key"/>...</details> structure is used.
    const sectionImgAltKeys = new Map<string, string[]>();
    const detailsRegex = /<details[^>]*>\s*<summary[^>]*>([\s\S]*?)<\/summary>([\s\S]*?)<\/details>/gi;
    let detailsMatch;
    while ((detailsMatch = detailsRegex.exec(markdown)) !== null) {
      const sectionLabel = (detailsMatch[1] || '')
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/gi, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toUpperCase();
      const body = detailsMatch[2] || '';
      const imgAltKeys: string[] = [];
      const imgRegex = /<img[^>]*alt=["']([^"']*)["'][^>]*\/?>/gi;
      let imgMatch;
      while ((imgMatch = imgRegex.exec(body)) !== null) {
        const altKey = imgMatch[1].trim();
        if (altKey && allFiles[altKey]) {
          imgAltKeys.push(altKey);
        }
      }
      if (imgAltKeys.length > 0) {
        sectionImgAltKeys.set(sectionLabel, imgAltKeys);
      }
    }

    // Find the img alt keys for the currently active section by fuzzy label matching
    let imgAltKeysForSection: string[] = [];
    sectionImgAltKeys.forEach((keys, sectionLabel) => {
      if (sectionLabel.includes(activeSection) || activeSection.includes(sectionLabel)) {
        imgAltKeysForSection = keys;
      }
    });

    // Collect all valid file items for those keys
    const isValidFile = (item: any) =>
      item && typeof item === 'object' && item.data && (item.filename || item.file_extension);

    for (const key of imgAltKeysForSection) {
      const fileItems = Array.isArray(allFiles[key]) ? allFiles[key].filter(isValidFile) : [];
      if (fileItems.length > 0) return fileItems;
    }
    return [];
  }, [summaryContext.activeSummaryMessage, summaryContext.activeInsightSection]);

  const shouldShowPresentationDeckButton = activeSectionFiles.length > 0;

  const handlePresentationDeckDownload = () => {
    const deck = activeSectionFiles[0];
    if (!deck || !deck.data) return;
    const link = document.createElement('a');
    const contentType =
      deck.content_type ||
      'application/vnd.openxmlformats-officedocument.presentationml.presentation';
    link.href = `data:${contentType};base64,${deck.data}`;
    link.download =
      deck.filename || `presentation${deck.file_extension || '.pptx'}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    callLogEvent(
      'CLICKED_ON_NEW_DAILOG_PRESENTATION_DECK_BUTTON',
      `Downloaded presentation deck: ${deck.filename || 'presentation'}`
    );
  };

  return (
    <div>
      {/* <TabTitle
				title={''}
				centerTitle={'UAE MT'}
				variant="uaemt"
				handleClick={handleResetToNewChat}
				chatTitle={'New Chat'}
				isBackBtn={showDashboard}
				handleBack={() => setShowDashboard(false)}
				isRecentQueries={true}
				handleRecentQueries={showRecentQueries}
			/> */}
      {showDashboard ? 'showDashboard' : 'NO Dashboard'}
      {!showDashboard ? (
        // when the chat panel is docked (open but not expanded) shrink the main content
        <div
          className={styles.mainDiv}
          style={
            mainStyle
              ? mainStyle
              : isChatPanelOpen && !isChatPanelExpanded
                ? { marginRight: isMobile ? undefined : 360 }
                : undefined
          }
        >
          {messages?.length === 0 &&
            (disableSummaryBtn ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100vh',
                }}
              >
                <CircularProgress size={80} />
              </div>
            ) : (
              // Otherwise, show the list of cards
              <DashboardListInChat
                handleViewSummary={handleSummary}
                handleDashboard={handleDashboardClick}
                onPage='NEW_DAILOG'
                loading={disableSummaryBtn}
                loadingTitle={pageTitle}
              />
            ))}

          {/* code for sidePanel */}
          {/*
            Ensure the recent-queries right-panel stacks above the chat panel.
            Chat panel uses zIndex:1300 (docked Box) and Ask button uses zIndex:1400,
            so set this panel above those values. Keep only zIndex change here to
            avoid layout side-effects.
          */}
          <div
            className={`right-panel ${isPanelOpen ? 'open' : ''}`}
            style={{
              zIndex: 1500,
              display: 'flex',           // Use flex to manage header and content
              flexDirection: 'column',    // Stack header on top of content
              overflow: 'hidden'         // Prevent the main panel from scrolling
            }}
          >
            {isLoading ? (
              <div className={'loaderWrapperRightPanel'}>
                <Spinner animation='border' variant='primary'>
                  <span className='visually-hidden'></span>
                </Spinner>
              </div>
            ) : (
              <>
                {/* Header: This stays at the top */}
                <Box
                  className="mb14Percent"
                  sx={{
                    px: 2,
                    py: 1.5,
                    background: 'rgb(14, 90, 167)',
                    color: '#fff',
                    boxShadow: 'inset 0 -1px 0 rgba(255,255,255,0.04)',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    borderRadius: '0',
                    flexShrink: 0, // Prevent the header from shrinking
                  }}
                >
                  <div
                    onClick={togglePanel}
                    className='cursor-pointer flex-align-items-center-space-between'
                  >
                    <h5>Recent Queries</h5> <CloseIcon />
                  </div>
                </Box>

                {/* Content: Only this part will scroll */}
                <div
                  className='p20'
                  style={{
                    flex: 1,            // Take up all remaining space
                    overflowY: 'auto',  // Enable vertical scrolling
                    overflowX: 'hidden' // Prevent horizontal scroll
                  }}
                >
                  {chatHistory && chatHistory.length > 0 ? (
                    chatHistory?.map((element: any) => {
                      return (
                        <p
                          key={element.id || element.question} // Added key for list rendering
                          className={`${styles.query} ${styles.sentMessage}`}
                          style={{
                            float: 'right',
                            clear: 'both',
                            display: 'block',
                            width: 'fit-content',
                            marginBottom: '8px',
                            cursor: 'pointer',
                            border: '1px solid #D7E5F8'
                          }}
                          onClick={() => getRecentQueryDetails(element)}
                        >
                          {element.question}
                        </p>
                      );
                    })
                  ) : (
                    <p className={styles.emptyQueries}>No Recent queries</p>
                  )}

                  {chatHistory && chatHistory.length > 0 && (
                    <div style={{ clear: 'both', textAlign: 'right', paddingTop: '10px' }}>
                      <Button
                        className={styles.clearAll}
                        onClick={clearAllRecentQueries}
                        sx={{ textTransform: 'none', fontWeight: 'bold' }}
                      >
                        CLEAR ALL
                      </Button>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
          <div>
            {messages?.length > 0 && (
              <div className={styles.messages}>
                <MessageList
                  uiMode='summary'
                  messages={summaryMessages}
                  allMessages={messages}
                  onPinToggle={handlePinToggle}
                  onDeleteMessage={handleDeleteSummary}
                    isInsightsNavOpen={isInsightsNavOpen}
                    setIsInsightsNavOpen={setIsInsightsNavOpen}
                    isSummaryHistoryOpen={isSummaryHistoryOpen}
                    setIsSummaryHistoryOpen={setIsSummaryHistoryOpen}
                    isFilterDrawerOpen={isFilterDrawerOpen}
                    setIsFilterDrawerOpen={setIsFilterDrawerOpen}
                    showFilterHelp={showFilterHelp}
                    setShowFilterHelp={setShowFilterHelp}
                    onSummaryToolbarStateChange={setSummaryToolbarState}
                    onSummaryContextChange={setSummaryContext}
                  // Child returns only the filtered summary array. Merge feedback
                  // changes back into the full `messages` state so we don't replace
                  // the parent's message list with the filtered subset (which
                  // caused summaries to disappear).
                  handleChange={(updatedSummary: any) => {
                    try {
                      const merged = (messages || []).map((m: any) => {
                        const match = (updatedSummary || []).find(
                          (s: any) => s.request_id === m.request_id
                        );
                        if (match) {
                          // Only copy feedback related flags to avoid overwriting
                          // other fields unintentionally.
                          return {
                            ...m,
                            is_liked: match.is_liked,
                            is_disliked: match.is_disliked,
                          };
                        }
                        return m;
                      });
                      handleMessages(merged);
                    } catch (e) {
                      // Fallback to original behavior if something unexpected happens
                      handleMessages(updatedSummary);
                    }
                  }}
                  title={pageTitle}
                  disableSummaryBtn={disableSummaryBtn}
                  handleSummary2={handleSummary2}
                  handleSummary={handleSummary}
                />
              </div>
            )}
          </div>

          {/* Floating Ask button removed from the inline layout; replace with fixed-position floating button below */}
        </div>
      ) : (
        <PBIDashboard
          title={pageTitle}
          dashboardURL={dashboardURL}
          onPage={'NEW_DIALOG'}
        />
      )}

      {/* Chat Panel: render as docked panel when opened (not expanded), otherwise show overlay Drawer */}
      {isChatPanelOpen && !isChatPanelExpanded ? (
        <Box
          sx={{
            position: 'fixed',
            right: 0,
            left: { xs: 0, sm: 'auto' },
            top: 0,
            bottom: 0,
            // When user resizes the panel we set an explicit pixel width. Otherwise
            // fall back to responsive defaults (100vw on xs, 30% on sm+).
            width: chatPanelWidth
              ? `${chatPanelWidth}px`
              : { xs: '100vw', sm: '30%' },
            maxWidth: '100%',
            boxSizing: 'border-box',
            zIndex: 1300,
            bgcolor: 'background.paper',
            boxShadow: '-4px 0 12px rgba(0,0,0,0.08)',
            display: 'flex',
            flexDirection: 'column',
            // ensure we create a stacking context for the drag handle
          }}
        >
          {/* Left drag handle for resizing the docked panel (desktop only) */}
          {!isMobile && (
            <div
              aria-hidden
              onMouseDown={onHandleMouseDown}
              role='separator'
              aria-label='Resize chat panel'
              style={{
                position: 'absolute',
                // place the handle slightly outside the left border of the panel so it's clearly an external affordance
                // use -12 so the visible bar sits very close (~2px gap) to the panel edge
                left: -12,
                top: 0,
                bottom: 0,
                // a slightly larger hit area makes dragging easier on desktop
                width: 16,
                cursor: 'ew-resize',
                zIndex: 1600,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'transparent',
              }}
            >
              {/* Visible vertical indicator to show the panel is draggable */}
              <div
                style={{
                  width: 4,
                  height: '10%',
                  borderRadius: 2,
                  // subtle gradient matching app accent so it's visible but not intrusive
                  background:
                    'linear-gradient(180deg, rgba(143,59,255,0.95), rgba(47,136,255,0.95))',
                  boxShadow: '0 0 8px rgba(47,136,255,0.12)',
                }}
              />
            </div>
          )}
          {/* Header with expand and close */}
          <Box
            sx={{
              px: 2,
              py: 0.5,
              background: 'rgb(14, 90, 167)',
              color: '#fff',
              boxShadow: 'inset 0 -1px 0 rgba(255,255,255,0.10)',
              minHeight: '56px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Box>
                <Typography
                  variant='subtitle2'
                  sx={{ fontWeight: 600, fontSize: '13px', lineHeight: 1 }}
                >
                  Ask Dialogue with Data!
                </Typography>
                <Typography
                  variant='caption'
                  sx={{ opacity: 0.92, display: 'block', fontSize: '10px' }}
                >
                  Your AI partner for simple, data-driven answers
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                  // background: 'rgba(255,255,255,0.16)',
                  border: '1px solid rgba(255,255,255,0.24)',
                  borderRadius: '999px',
                  px: 0.5,
                  py: 0.2,
                }}
              >
                <Tooltip title='Recent Queries'>
                  <IconButton
                    onClick={showRecentQueries}
                    sx={{
                      color: '#fff',
                      width: 34,
                      height: 34,
                      p: '6px',
                      '&:hover': { background: 'rgba(255,255,255,0.18)' },
                    }}
                  >
                    <HistoryIcon sx={{ fontSize: 20 }} />
                  </IconButton>
                </Tooltip>
                <Tooltip title='New Chat'>
                  <IconButton
                    onClick={clearChatHistory}
                    sx={{
                      color: '#fff',
                      width: 34,
                      height: 34,
                      p: '6px',
                      '&:hover': { background: 'rgba(255,255,255,0.18)' },
                    }}
                  >
                    <Add sx={{ fontSize: 20 }} />
                  </IconButton>
                </Tooltip>
                {!isMobile && (
                  <IconButton
                    onClick={() => {
                      setIsChatPanelExpanded(true);
                      callLogEvent(
                        'CLICKED_ON_NEW_DAILOG_EXPAND_BUTTON',
                        'User expanded the chat panel' +
                        (lastUsedSuggestion
                          ? '; last suggestion: ' + lastUsedSuggestion
                          : '')
                      );
                    }}
                    aria-label='Expand panel'
                    sx={{
                      color: '#fff',
                      width: 34,
                      height: 34,
                      p: '6px',
                      '&:hover': { background: 'rgba(255,255,255,0.18)' },
                    }}
                  >
                    <ChevronLeft sx={{ fontSize: 20 }} />
                  </IconButton>
                )}
                <IconButton
                  onClick={() => {
                    setIsChatPanelOpen(false);
                    try {
                      callLogEvent(
                        'CLICKED_ON_NEW_DAILOG_CLOSE_BUTTON',
                        'User closed the chat panel'
                      );
                    } catch (e) { }
                  }}
                  sx={{
                    color: '#fff',
                    width: 34,
                    height: 34,
                    p: '6px',
                    '&:hover': { background: 'rgba(255,255,255,0.18)' },
                  }}
                >
                  <CloseIcon sx={{ fontSize: 20 }} />
                </IconButton>
              </Box>
            </Box>
          </Box>

          {/* Tips right below header */}
          {showTipsBox && (
            <Box
              onClick={(e) => e.stopPropagation()}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                p: 0.75,
                bgcolor: '#ebf4ff',
                borderBottom: '1px solid #d8e8fb',
              }}
            >
              <Typography
                variant='body2'
                sx={{
                  color: '#1d3552',
                  fontSize: '0.65rem',
                  lineHeight: 1.2,
                  fontWeight: '400',
                }}
              >
                <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                  <img
                    src={TipsIcon}
                    alt='Tips'
                    style={{
                      width: 16,
                      height: 16,
                      marginRight: 8,
                      verticalAlign: 'middle',
                    }}
                  />
                  <span>
                    Tips: For better insights, include Category, Time Period,
                    Geography, and Measure. {dataRangeText}
                  </span>
                </span>
              </Typography>
              <button
                type='button'
                aria-label='close tips'
                title='Dismiss tips'
                onClick={(e) => {
                  e.stopPropagation();
                  try {
                    e.preventDefault();
                  } catch (_) { }
                  try {
                    (e.nativeEvent as any)?.stopImmediatePropagation?.();
                  } catch (_) { }
                  try {
                    localStorage.setItem('uae_mt_tips_dismissed', 'true');
                  } catch (_) { }
                  try {
                    callLogEvent(
                      'CLICKED_NEW_DIALOG_TIPS_CLOSE_BUTTON',
                      'User dismissed tips'
                    );
                  } catch (e) { }
                  setShowTipsBox(false);
                }}
                style={{
                  background: 'transparent',
                  border: 'none',
                  padding: 6,
                  cursor: 'pointer',
                  color: '#355275',
                  display: 'inline-flex',
                  alignItems: 'center',
                  zIndex: 1401,
                  pointerEvents: 'auto',
                }}
              >
                <CloseIcon fontSize='inherit' />
              </button>
            </Box>
          )}

          {/* Chat History Area */}
          <Box
            sx={{
              flex: 1,
              overflow: 'hidden',
              minHeight: 0,
              background:
                'linear-gradient(180deg, rgba(248,251,255,0.75) 0%, #ffffff 22%)',
              // Ensure chat message typography matches summary sizing
              fontSize: '0.7rem',
              // Constrain icon and button sizes inside the chat history so they don't appear oversized
              '& .MuiSvgIcon-root': { fontSize: '.7rem' },
              '& .MuiButton-root': { fontSize: '0.8rem' },
              // Keep avatar / small inline icons constrained
              '& .chat-avatar img, & .inline-icon img': {
                maxHeight: '.8rem',
                maxWidth: '90%',
              },
              // Allow message images (base64/data URIs or images marked with chatImageSize) to render at natural size
              "& img.chatImageSize, & img[src^='data:']": {
                maxWidth: '70%',
                maxHeight: '80%',
                height: 'auto',
              },
              position: 'relative',
              px: 0.5,
            }}
          >
            <MessageList
              uiMode='chat'
              messages={qaMessages}
              tipVisible={showTipsBox}
              allMessages={messages}
              onPinToggle={handlePinToggle}
              onDeleteMessage={handleDeleteSummary}
              // Merge any updates coming from the child back into the full messages
              // array so the parent doesn't get replaced by a filtered subset.
              handleChange={(updatedSubset: any) => {
                try {
                  const merged = (messages || []).map((m: any) => {
                    const match = (updatedSubset || []).find(
                      (s: any) => s.request_id === m.request_id
                    );
                    if (match) {
                      return {
                        ...m,
                        is_liked: match.is_liked,
                        is_disliked: match.is_disliked,
                      };
                    }
                    return m;
                  });
                  handleMessages(merged);
                } catch (e) {
                  handleMessages(updatedSubset);
                }
              }}
              setInputValue={setInputValue}
              setSuggestions={setLatestSuggestions}
              isIdeal={isIdeal}
              onSend={handleSend}
              title={pageTitle}
              disableSummaryBtn={disableSummaryBtn}
            />
          </Box>

          {/* Dialog Cues (stacked, full-width) - placed above the input area to avoid interfering with messages */}
          {visibleSuggestions && visibleSuggestions.length > 0 && (
            <Box
              sx={{
                px: 1,
                py: 0.6,
                bgcolor: '#ffffff',
                borderTop: '1px solid #edf2fa',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.75 }}>
                <Box
                  sx={{
                    width: 24,
                    height: 24,
                    bgcolor: '#eef5ff',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mr: 1,
                  }}
                >
                  <img
                    src={TipsIcon}
                    alt='cues'
                    style={{ width: 12, height: 12 }}
                  />
                </Box>
                <Typography
                  variant='subtitle2'
                  sx={{ fontSize: '0.72rem', fontWeight: 600, color: '#223a59', flex: 1 }}
                >
                  Dialog Cues
                </Typography>
                <IconButton
                  size='small'
                  onClick={() => setVisibleSuggestions([])}
                  sx={{ p: 0.25, color: '#8a9bba', '&:hover': { color: '#1f3b5b' } }}
                  aria-label='close dialog cues'
                >
                  <CloseIcon sx={{ fontSize: 16 }} />
                </IconButton>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 0.5,
                  pb: 0.5,
                }}
              >
                {visibleSuggestions.map((s: string, i: number) => (
                  <Button
                    key={i}
                    variant='outlined'
                    onClick={() => handleSuggestionClick(s)}
                    sx={{
                      textTransform: 'none',
                      justifyContent: 'flex-start',
                      fontSize: '0.55rem',
                      borderRadius: '8px',
                      padding: '4px 8px',
                      borderColor: '#d7e7ff',
                      color: '#1f3b5b',
                      background: '#ffffff',
                      minHeight: '24px',
                      lineHeight: 1,
                      alignSelf: 'flex-start',
                      // maxWidth: { xs: '100%', sm: '60%' },
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      '&:hover': {
                        background: '#f3f8ff',
                        borderColor: '#bed7ff',
                      },
                    }}
                  >
                    {s}
                  </Button>
                ))}
              </Box>
            </Box>
          )}

          {/* Chat Input Area */}
          <Box
            sx={{
              p: 0.5,
              borderTop: '1px solid #dce7f5',
              bgcolor: '#ffffff',
              // On mobile leave extra bottom padding so input is visible above virtual keyboard
              pb: isMobile ? '32px' : 0,
            }}
          >
            <InputField
              onSend={handleSend}
              onEnter={handleSend}
              resetToNewChat={handleResetToNewChat}
              isIdeal={isIdeal}
              dataSource={currentDataSource}
              inputValue={inputValue}
              setInputValue={setInputValue}
              hidden={!restrictedUsers.includes(currentUserEmail!)}
              handleDocId={(docId: string) => setAttachmentId(docId)}
              pageTitle={pageTitle}
              setSuggestions={setLatestSuggestions}
            />
          </Box>
        </Box>
      ) : (
        <Drawer
          anchor='right'
          open={isChatPanelOpen}
          onClose={() => {
            setIsChatPanelOpen(false);
            try {
              callLogEvent(
                'CLICKED_ON_NEW_DAILOG_CLOSE_BUTTON',
                'User closed the chat panel'
              );
            } catch (e) { }
          }}
          PaperProps={{
            sx: {
              // When expanded, use 75% of viewport width on small+ screens.
              // When not expanded (but open), fall back to previous fixed widths.
              width: isChatPanelExpanded
                ? { xs: '100%', sm: '75%', md: '75%' }
                : { xs: '100%', sm: '30%', md: '30%' },
              background: '#f8fbff',
              borderLeft: '1px solid #dce9f8',
              boxShadow: '-10px 0 28px rgba(15, 23, 42, 0.14)',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
            },
          }}
        >
          {/* Drawer Header */}
          <Box
            sx={{
              px: 2,
              py: 0.75,
              background: 'rgb(14, 90, 167)',
              color: '#fff',
              boxShadow: 'inset 0 -1px 0 rgba(255,255,255,0.10)',
              minHeight: '64px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Box>
                <Typography
                  variant='subtitle1'
                  sx={{ fontWeight: 600, fontSize: '15px', lineHeight: 1 }}
                >
                  Ask Dialogue with Data!
                </Typography>
                <Typography
                  variant='caption'
                  sx={{ opacity: 0.9, display: 'block', fontSize: '11px' }}
                >
                  Your AI partner for simple, data-driven answers
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                  // background: 'rgba(255,255,255,0.16)',
                  border: '1px solid rgba(255,255,255,0.24)',
                  borderRadius: '999px',
                  px: 0.5,
                  py: 0.2,
                }}
              >
                <Tooltip title='Recent Queries'>
                  <IconButton
                    onClick={showRecentQueries}
                    sx={{
                      color: '#fff',
                      width: 32,
                      height: 32,
                      p: '4px',
                      '&:hover': { background: 'rgba(255,255,255,0.18)' },
                    }}
                  >
                    <HistoryIcon sx={{ fontSize: 18 }} />
                  </IconButton>
                </Tooltip>
                <Tooltip title='New Chat'>
                  <IconButton
                    onClick={clearChatHistory}
                    sx={{
                      color: '#fff',
                      width: 32,
                      height: 32,
                      p: '4px',
                      '&:hover': { background: 'rgba(255,255,255,0.18)' },
                    }}
                  >
                    <Add sx={{ fontSize: 18 }} />
                  </IconButton>
                </Tooltip>
                {!isMobile && (
                  <IconButton
                    onClick={() => {
                      setIsChatPanelExpanded(false);
                      callLogEvent(
                        'CLICKED_ON_NEW_DAILOG_COLLAPSE_BUTTON',
                        'User collapsed the chat panel' +
                        (lastUsedSuggestion
                          ? '; last suggestion: ' + lastUsedSuggestion
                          : '')
                      );
                    }}
                    aria-label='Collapse panel'
                    sx={{
                      color: '#fff',
                      width: 32,
                      height: 32,
                      p: '4px',
                      '&:hover': { background: 'rgba(255,255,255,0.18)' },
                    }}
                  >
                    <ChevronRight sx={{ fontSize: 18 }} />
                  </IconButton>
                )}
                <IconButton
                  onClick={() => {
                    setIsChatPanelOpen(false);
                    try {
                      callLogEvent(
                        'CLICKED_ON_NEW_DAILOG_CLOSE_BUTTON',
                        'User closed the chat panel'
                      );
                    } catch (e) { }
                  }}
                  sx={{
                    color: '#fff',
                    width: 32,
                    height: 32,
                    p: '4px',
                    '&:hover': { background: 'rgba(255,255,255,0.18)' },
                  }}
                >
                  <CloseIcon sx={{ fontSize: 20 }} />
                </IconButton>
              </Box>
            </Box>
          </Box>

          {/* Tips right below header */}
          {showTipsBox && (
            <Box
              onClick={(e) => e.stopPropagation()}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                p: 0.85,
                bgcolor: '#ebf4ff',
                borderBottom: '1px solid #d8e8fb',
              }}
            >
              <Typography
                variant='body2'
                sx={{
                  color: '#1d3552',
                  fontSize: '0.65rem',
                  lineHeight: 1.15,
                  fontWeight: 400,
                }}
              >
                <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                  <img
                    src={TipsIcon}
                    alt='Tips'
                    style={{
                      width: 16,
                      height: 16,
                      marginRight: 8,
                      verticalAlign: 'middle',
                    }}
                  />
                  <span>
                    Tips: For better insights, include Category, Time Period,
                    Geography, and Measure. {dataRangeText}
                  </span>
                </span>
              </Typography>
              <button
                type='button'
                aria-label='close tips'
                title='Dismiss tips'
                onClick={(e) => {
                  e.stopPropagation();
                  try {
                    e.preventDefault();
                  } catch (_) { }
                  try {
                    (e.nativeEvent as any)?.stopImmediatePropagation?.();
                  } catch (_) { }
                  try {
                    localStorage.setItem('uae_mt_tips_dismissed', 'true');
                  } catch (_) { }
                  try {
                    callLogEvent(
                      'CLICKED_NEW_DIALOG_TIPS_CLOSE_BUTTON',
                      'User dismissed tips'
                    );
                  } catch (e) { }
                  setShowTipsBox(false);
                }}
                style={{
                  background: 'transparent',
                  border: 'none',
                  padding: 6,
                  cursor: 'pointer',
                  color: '#355275',
                  display: 'inline-flex',
                  alignItems: 'center',
                  zIndex: 1401,
                  pointerEvents: 'auto',
                }}
              >
                <CloseIcon fontSize='small' />
              </button>
            </Box>
          )}

          {/* Chat History Area */}
          <Box
            sx={{
              flex: 1,
              overflow: 'hidden',
              minHeight: 0,
              // Keep drawer chat typography consistent with docked view
              fontSize: '0.7rem',
              '& .MuiSvgIcon-root': { fontSize: '.7rem' },
              '& .MuiButton-root': { fontSize: '0.7rem' },
              // Keep avatar / inline icons constrained
              '& .chat-avatar img, & .inline-icon img': {
                maxHeight: '.0rem',
                maxWidth: '100%',
              },
              // Allow message images (base64/data URIs or images marked with chatImageSize) to render at natural size
              "& img.chatImageSize, & img[src^='data:']": {
                maxWidth: '55%',
                maxHeight: '80%',
                height: 'auto',
              },
              position: 'relative',
              background:
                'linear-gradient(180deg, rgba(248,251,255,0.75) 0%, #ffffff 22%)',
              px: 0.5,
            }}
          >
            <MessageList
              uiMode='chat'
              messages={qaMessages}
              tipVisible={showTipsBox}
              allMessages={messages}
              onPinToggle={handlePinToggle}
              onDeleteMessage={handleDeleteSummary}
              // Merge child updates into the full messages array to avoid
              // accidentally replacing parent state with a subset.
              handleChange={(updatedSubset: any) => {
                try {
                  const merged = (messages || []).map((m: any) => {
                    const match = (updatedSubset || []).find(
                      (s: any) => s.request_id === m.request_id
                    );
                    if (match) {
                      return {
                        ...m,
                        is_liked: match.is_liked,
                        is_disliked: match.is_disliked,
                      };
                    }
                    return m;
                  });
                  handleMessages(merged);
                } catch (e) {
                  handleMessages(updatedSubset);
                }
              }}
              setInputValue={setInputValue}
              setSuggestions={setLatestSuggestions}
              isIdeal={isIdeal}
              onSend={handleSend}
              title={pageTitle}
              disableSummaryBtn={disableSummaryBtn}
            />
          </Box>

          {/* Dialog Cues (stacked, full-width) - placed above the input area to avoid interfering with messages */}
          {visibleSuggestions && visibleSuggestions.length > 0 && (
            <Box
              sx={{
                px: 1,
                py: 0.6,
                bgcolor: '#ffffff',
                borderTop: '1px solid #edf2fa',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.65 }}>
                <Box
                  sx={{
                    width: 20,
                    height: 20,
                    bgcolor: '#eef5ff',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <img
                    src={TipsIcon}
                    alt='cues'
                    style={{ width: 10, height: 10 }}
                  />
                </Box>
                <Typography
                  variant='subtitle2'
                  sx={{ fontSize: '0.72rem', fontWeight: 600, color: '#223a59', flex: 1 }}
                >
                  Dialog Cues
                </Typography>
                <IconButton
                  size='small'
                  onClick={() => setVisibleSuggestions([])}
                  sx={{ p: 0.25, color: '#8a9bba', '&:hover': { color: '#1f3b5b' } }}
                  aria-label='close dialog cues'
                >
                  <CloseIcon sx={{ fontSize: 16 }} />
                </IconButton>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 0.4,
                  pb: 0.25,
                }}
              >
                {visibleSuggestions.map((s: string, i: number) => (
                  <Button
                    key={i}
                    variant='outlined'
                    onClick={() => handleSuggestionClick(s)}
                    sx={{
                      textTransform: 'none',
                      justifyContent: 'flex-start',
                      fontSize: '0.55rem',
                      borderRadius: '8px',
                      padding: '4px 8px',
                      borderColor: '#d7e7ff',
                      color: '#1f3b5b',
                      background: '#ffffff',
                      minHeight: '24px',
                      lineHeight: 1,
                      alignSelf: 'flex-start',
                      // maxWidth: { xs: '100%', sm: '60%' },
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      '&:hover': {
                        background: '#f3f8ff',
                        borderColor: '#bed7ff',
                      },
                    }}
                  >
                    {s}
                  </Button>
                ))}
              </Box>
            </Box>
          )}

          {/* Chat Input Area */}
          <Box
            sx={{
              p: 1,
              borderTop: '1px solid #dce7f5',
              bgcolor: '#ffffff',
            }}
          >
            <InputField
              onSend={handleSend}
              onEnter={handleSend}
              resetToNewChat={handleResetToNewChat}
              isIdeal={isIdeal}
              dataSource={currentDataSource}
              inputValue={inputValue}
              setInputValue={setInputValue}
              hidden={!restrictedUsers.includes(currentUserEmail!)}
              handleDocId={(docId: string) => setAttachmentId(docId)}
              pageTitle={pageTitle}
              setSuggestions={setLatestSuggestions}
            />
          </Box>
        </Drawer>
      )}

      {/* Floating Ask button (fixed to bottom-right) */}
      {(messages?.length > 0 ||
        localStorage.getItem('DataSource') === 'r_and_d' ||
        localStorage.getItem('DataSource') === 'SpendWise') &&
        !isChatPanelOpen && (
          <Box
            sx={{
              position: 'fixed',
              right: { xs: 16, sm: 24 },
              bottom: { xs: 16, sm: 24 },
              zIndex: 1400,
              display: 'flex',
              alignItems: 'center',
              gap: 0.75,
            }}
          >
            <Button
              onClick={() => {
                setIsChatPanelOpen(true);
                setIsChatPanelExpanded(false);
                callLogEvent(
                  'CLICKED_ON_NEW_DAILOG_ASK_BUTTON',
                  'User clicked Ask Dwd button to open the chat panel'
                );
              }}
              onMouseEnter={() => setIsAskHovered(true)}
              onMouseLeave={() => setIsAskHovered(false)}
              startIcon={
                <img
                  src={ChatIcon}
                  alt='Ask Dwd'
                  style={{
                    width: 15,
                    height: 13,
                    display: 'inline-block',
                    paddingLeft: '5',
                  }}
                />
              }
              disableElevation
              sx={{
                textTransform: 'none',
                color: '#fff',
                background: 'rgb(14, 90, 167)',
                borderRadius: '999px',
                padding: isAskHovered ? '9px 16px' : '7px 11px',
                minWidth: isAskHovered ? undefined : 30,
                boxShadow: '0 10px 24px rgba(47,136,255,0.26)',
                border: '1px solid rgba(255,255,255,0.24)',
                '&:hover': {
                  background:
                    'rgb(14, 90, 167)',
                  transform: 'translateY(-1px)',
                },
                fontWeight: 500,
                transition:
                  'padding 160ms ease, min-width 160ms ease, transform 120ms ease',
                fontSize: '0.65rem',
              }}
            >
              {isAskHovered ? 'Have a question? Ask Dwd!' : 'Ask Dwd!'}
            </Button>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.65 }}>
              {shouldShowPresentationDeckButton && (
                <Tooltip
                  title={
                    activeSectionFiles[0]?.filename ||
                    'Download presentation deck'
                  }
                  placement='left'
                >
                  <IconButton
                    aria-label='Download presentation deck'
                    onClick={handlePresentationDeckDownload}
                    sx={{
                      color: '#fff',
                      background: 'rgb(14, 90, 167)',
                      '&:hover': {
                        background: 'rgb(14, 90, 167)',
                        transform: 'translateY(-1px)',
                      },
                      boxShadow: '0 10px 24px rgba(47,136,255,0.22)',
                      width: 30,
                      height: 30,
                      borderRadius: '6px',
                      border: '1px solid rgba(255,255,255,0.24)',
                    }}
                  >
                    <Download sx={{ fontSize: '16px' }} />
                  </IconButton>
                </Tooltip>
              )}

              {/* Icon on the right side of the Ask button to open the user guide */}
              <IconButton
                aria-label='Open user guide'
                onClick={() => {
                  setIsUserGuideOpen(true);
                  callLogEvent(
                    'CLICKED_ON_NEW_DAILOG_USER_GUIDE_BUTTON',
                    'User opened the user guide'
                  );
                }}
                sx={{
                  color: '#fff',
                  background: 'rgb(14, 90, 167)',
                  '&:hover': {
                    background:
                      'rgb(14, 90, 167)',
                    transform: 'translateY(-1px)',
                  },
                  boxShadow: '0 10px 24px rgba(47,136,255,0.22)',
                  width: 30,
                  height: 30,
                  borderRadius: '50%',
                  border: '1px solid rgba(255,255,255,0.24)',
                }}
              >
                <HelpOutline sx={{ fontSize: '17px' }} />
              </IconButton>
            </Box>
            <UserGuideUaeMt
              open={isUserGuideOpen}
              onClose={() => setIsUserGuideOpen(false)}
            />
          </Box>
        )}
    </div>
  );
};

export default Layout(UaeMtChatBotComponent);
